<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::sidebar-->
      <sidebar-component classMenu="DashboardFullfilment"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
        <!--begin::content-->
        <div class="page-content">
          <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div
                class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
              >
                <div class="col-lg-2 col-xl-3 col-sm-3 col-xs-3 col-md-3">
                  <h4 class="mb-3 mb-md-0">
                    {{ $t("proformaInvoiceDashboard") }}
                  </h4>
                </div>

                <div class="col-lg-10 col-xl-9 col-sm-9 col-xs-9 col-md-9">
                  <div class="d-flex flex-wrap">
                    <div
                      class="input-group flatpickr wd-250 me-2 mb-2 mb-md-0"
                      id="dashboardDate"
                    >
                      <date-range-picker
                        style="width: 100%"
                        @change="loadData"
                        control-container-class="form-control"
                        :locale-data="locale"
                        v-model="dateFilter"
                        :opens="opens"
                        :singleDatePicker="false"
                        :timePicker24Hour="true"
                        :timePicker="true"
                        :showWeekNumbers="false"
                      >
                      </date-range-picker>
                    </div>
                    <div class="input-group wd-250 me-2 mb-2 mb-md-0">
                      <multiselect
                        @search-change="asyncSearchCompany"
                        v-model="companyDashboard"
                        :options="fetchCompany"
                        label="name"
                        :searchable="true"
                        track-by="name"
                        ref="inputCompany"
                        placeholder="Please Select Company"
                        :custom-label="company_label"
                        @input="loadData"
                      >
                        <span slot="noResult">-</span>
                      </multiselect>
                    </div>
                    <button
                      type="button"
                      style="max-height: 40px"
                      @click.prevent="loadData"
                      class="btn btn-primary btn-icon-text mb-2 mb-md-0 btn-block btn-floating"
                    >
                      GO
                    </button>
                    <span style="width: 5px"> </span>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <!-- Jakarta -->
                  <div class="row mb-4" style="height: 200px">
                    <div class="col-lg-12">
                      <!-- <LineChartGenerator :chart-options="chartOptions"
                                                :chart-data="chartDataLine" :chart-id="chartId"
                                                :dataset-id-key="datasetIdKey" :plugins="plugins"
                                                :css-classes="cssClasses" :styles="myStyles" :width="width"
                                                :height="height" /> -->
                      <Bar
                        :chart-options="chartOptions"
                        :chart-data="chartDataLine"
                        :chart-id="chartId"
                        :dataset-id-key="datasetIdKey"
                        :plugins="plugins"
                        :css-classes="cssClasses"
                        :styles="myStyles"
                        :width="width"
                        :height="height"
                      />
                    </div>
                  </div>
                  <br />
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="row">
                        <div class="col-lg-2">
                          <div class="mb-3">
                            <label class="form-label">{{
                              $t("piNumber")
                            }}</label>
                            <input
                              type="text"
                              v-model="search.pi_number"
                              v-on:keyup.enter="loadItems"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-lg-2">
                          <div class="mb-3">
                            <label class="form-label">{{
                              $t("load_id")
                            }}</label>
                            <input
                              type="text"
                              v-model="search.load_id"
                              v-on:keyup.enter="loadItems"
                              class="form-control"
                            />
                          </div>
                        </div>
                        <div class="col-lg-2">
                          <div class="mb-3">
                            <label class="form-label">{{
                              $t("piStatus")
                            }}</label>
                            <!-- <input
                              type="text"
                              v-model="search.status"
                              v-on:keyup.enter="loadData"
                              class="form-control"
                            /> -->

                            <v-select
                              @input="loadItems"
                              :options="['CREATE', 'POST', 'PRINT']"
                              v-model="search.status"
                              v-bind:style="{ padding: 0 }"
                              class="form-control"
                              label="code"
                            ></v-select>
                          </div>
                        </div>
                        <div class="col-lg-2">
                          <div class="mb-3">
                            <label class="form-label">{{
                              $t("create_at_txt")
                            }}</label>
                            <date-range-picker
                              style="width: 100%"
                              @change="loadItems"
                              control-container-class="form-control"
                              :locale-data="locale"
                              v-model="dateFilterSearch"
                              :opens="opens"
                              :singleDatePicker="false"
                              :timePicker24Hour="true"
                              :timePicker="true"
                              :showWeekNumbers="false"
                            >
                            </date-range-picker>
                          </div>
                        </div>
                        <div class="col-lg-2">
                          <div class="mb-3">
                            <label class="form-label">Company</label>
                            <multiselect
                              @search-change="asyncSearchCompany"
                              v-model="company"
                              :options="fetchCompany"
                              label="name"
                              :searchable="true"
                              track-by="name"
                              ref="inputCompany"
                              placeholder="Please Select Company"
                              :custom-label="company_label"
                              @input="loadItems"
                            >
                              <span slot="noResult">-</span>
                            </multiselect>
                          </div>
                        </div>
                        <div class="col-lg-2 mt-4">
                          <div class="mb-3 mt-1">
                            <button
                              class="btn btn-primary mx-2"
                              type="button"
                              @click="loadItems"
                            >
                              {{ $t("search_txt") }}
                            </button>
                            <button
                              class="btn btn-success mx-2"
                              type="button"
                              @click="downloadData"
                            >
                              {{ $t("downloadData") }} .Xlsx
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mb-4">
                    <vue-good-table
                      title="dashboard-pi"
                      mode="remote"
                      :totalRows="totalRecords"
                      :line-numbers="true"
                      :isLoading.sync="isLoading"
                      :pagination-options="{
                        enabled: true,
                      }"
                      :rows="rows"
                      :columns="columns"
                    >
                      <!-- <div slot="table-actions">
                        <button class="btn btn-success btn-xs">
                          Export To Excel
                        </button>
                      </div> -->
                      <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'entries'">
                          <a
                            style="
                              color: #ab0635;
                              text-decoration: none;
                              cursor: pointer;
                            "
                            title="Detail Load Id"
                            @click.prevent="detailPi(props.row)"
                          >
                            {{ props.row.entries }}
                          </a>
                        </span>
                        <span v-else>
                          {{ props.formattedRow[props.column.field] }}
                        </span>
                      </template>
                    </vue-good-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>

    <!-- <modal-fullfilment-detail
      :showModal="showModalDetail"
      :data="detailData"
      @closeModal="closeMyModal"
    ></modal-fullfilment-detail> -->
    <modal-proformaInvoiceDetail
      :showModal="showModalPI"
      :data="this.detailData"
      @closeModal="closeMyModal"
    >
    </modal-proformaInvoiceDetail>
    <!-- <modal-productivity-detail :showModal="showModalDetail" :data="detailData"
            @closeModal="closeMyModal"></modal-productivity-detail>

        <modal-productivity-nasional :showModal="showModalNasional" :data="detailData"
            @closeModal="closeMyModal"></modal-productivity-nasional> -->
  </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import DateRangePicker from "vue2-daterange-picker";
import { Bar } from "vue-chartjs/legacy";
// import { Line as LineChartGenerator } from 'vue-chartjs'
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  LineElement,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Filler,
);

// import modalFullfilmentDetail from "@/components/modal/modalFullfilmentDetail.vue";
// import modalProductivityNasional from "@/components/modal/modalProductivityNasional.vue";
import ModalProformaInvoiceDetail from "@/components/modal/modalProformaInvoiceDetail.vue";
import multiselect from "vue-multiselect";

import moment from "moment";

export default {
  name: "DashboardProformaInvoice",
  props: {
    chartId: {
      type: String,
      default: "bar",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Object,
      default: () => {},
    },
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 200,
    },
  },
  components: {
    "sidebar-component": sidebarComponent,
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    // LineChartGenerator,
    Bar,
    // "modal-fullfilment-detail": modalFullfilmentDetail,
    "modal-proformaInvoiceDetail": ModalProformaInvoiceDetail,
    // "modal-productivity-nasional": modalProductivityNasional,
    DateRangePicker,
    multiselect,
  },
  data() {
    const startDate = moment().subtract(1, "months").format("YYYY-MM-DD");
    const endDate = moment().add(1, "months").calendar();

    return {
      chartDataLine: {
        labels: [],
        datasets: [],
      },
      fetchTruck: [],
      fetchBranch: [],
      type_truck: "",
      branch: "",
      type_truckFilter: [],
      branchFilter: [],
      chartOptions: {
        scales: {
          y: {
            stacked: true,
            ticks: {
              beginAtZero: true,
              min: 0,
              stepSize: 5,
            },
            gridLines: {
              display: true,
            },
          },
          x: {
            stacked: true,
            gridLines: {
              display: false,
            },
          },
        },
        legend: {
          display: true,
          position: "left",
        },
        responsive: true,
        maintainAspectRatio: false,
        onClick: (c, i) => {
          var labelDate = c.chart.config._config.data.labels[i[0].index];

          var label = this.chartDataLine.datasets[i[0].datasetIndex].label;
          this.clickDetailModal(label, labelDate);
        },
      },
      detailOpen: false,
      showModalDetail: false,
      showModalNasional: false,
      showModalPI: false,
      opens: "center",
      detailData: {},
      locale: {
        format: "yyyy-mm-dd",
      },
      permision_role: [],
      countData: [],
      dateFilter: {
        startDate,
        endDate,
      },
      dateFilterSearch: {
        startDate,
        endDate,
      },
      isLoading: false,
      rowsTable: [],
      totalRecords: 0,
      totalRecordsDetail: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },

      columns: [
        {
          label: this.$t("piNumber"),
          field: "pi_number",
        },
        {
          label: "#Enteries",
          field: "entries",
        },
        {
          label: "Total",
          field: "total",
        },
        {
          label: this.$t("create_at_txt"),
          field: "created_at",
        },
        {
          label: this.$t("piStatus"),
          field: "status",
        },
      ],
      bulan: [],
      cancel_from_customer: [],
      fullfill: [],
      not_fullfill: [],
      billable_not_found: [],
      billable_payable_not_found: [],
      deleted: [],
      edit_shipment: [],
      new_order: [],
      payable_not_found: [],
      total: [],
      rows: [],
      fetchCompany: [],
      company: null,
      companyDashboard: null,
      search: {},
    };
  },
  computed: {
    myStyles() {
      return {
        height: "100%",
        position: "relative",
      };
    },
  },
  watch: {},
  methods: {
    company_label(ev) {
      return ev.code + " | " + ev.name;
    },
    asyncSearchCompany(ev) {
      const baseURI =
        this.$settings.endPoint +
        "company/select?status=active&limit=10&name=" +
        ev;

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },
    loadCompany() {
      const baseURI =
        this.$settings.endPoint + "company/select?status=active&limit=10";

      return this.$http.get(baseURI).then((response) => {
        this.fetchCompany = response.data.datas.data;
      });
    },
    clickDetailModal(jenis, monthDetail) {
      this.showModalDetail = true;
      this.detailData = {
        jenis: jenis,
        start: moment(String(this.dateFilter.startDate)).format("YYYY-MM-DD"),
        end: moment(String(this.dateFilter.endDate)).format("YYYY-MM-DD"),
        branch: this.branch.branch_id == undefined ? "" : this.branch.branch_id,
        type:
          this.type_truck.type_truck == undefined
            ? ""
            : this.type_truck.type_truck,
        monthDetail: monthDetail,
      };
    },
    detailPi(row) {
      this.detailData["method"] = "detail";
      this.detailData["data"] = row;
      this.showModalPI = true;
      console.log(row);
    },
    closeMyModal() {
      this.showModalPI = false;
      // this.showModalNasional = false;
      // this.detailData = {};
    },

    // loadData() {
    //   let dataSend = {
    //     start: moment(String(this.dateFilter.startDate)).format("YYYY-MM-DD"),
    //     end: moment(String(this.dateFilter.endDate)).format("YYYY-MM-DD"),
    //     branch: this.branch == undefined ? null : this.branch.branch_id,
    //     type: this.type_truck == undefined ? null : this.type_truck.type_truck,
    //   };

    //   const baseURI =
    //     this.$settings.endPoint +
    //     "control-tower/transport-order-header/dashboard"; // ?start=" + dataSend.start + "&end=" + dataSend.end
    //   this.$http
    //     .post(baseURI, dataSend, { timeout: 10000 })
    //     .then((response) => {
    //       this.isLoading = false;
    //       if (response.status == 200) {
    //         this.bulan = response.data.bulan;
    //         this.cancel_from_customer = response.data.cancel_from_customer;
    //         this.fullfill = response.data.fullfill;
    //         this.not_fullfill = response.data.not_fullfill;

    //         this.billable_not_found = response.data.billable_not_found;
    //         this.billable_payable_not_found =
    //           response.data.billable_payable_not_found;

    //         this.deleted = response.data.deleted;
    //         this.edit_shipment = response.data.edit_shipment;
    //         this.new_order = response.data.new_order;
    //         this.payable_not_found = response.data.payable_not_found;

    //         this.total = response.data.total;
    //         this.loadGrafik();
    //       } else {
    //         this.errors = response.data.errors;
    //         this.resultError(response.data.errors);
    //       }
    //     })
    //     .catch((error) => {
    //       this.isLoading = false;
    //       if (error.code == "ECONNABORTED") {
    //         this.error("Please Check Your Internet Connection");
    //       } else {
    //         if (error.response) {
    //           if (error.response.status === 422) {
    //             this.errors = error.response.data.errors;
    //             this.resultError(error.response.data.errors);
    //           } else if (error.response.status === 500) {
    //             this.error(error.response.data.errors.message);
    //           } else {
    //             //this.$router.push("/page-not-found");
    //           }
    //         }
    //       }
    //     });
    // },

    loadData() {
      this.fade(true);
      const baseURI =
        this.$settings.endPointProformaInvoice +
        "v1/proforma-invoice/get-dashboard";
      let dataSend = {
        start: moment(String(this.dateFilter.startDate)).format("YYYY-MM-DD"), //this.dateFilter.startDate,  // moment(String(this.forms.join_date)).format('YYYY-MM-DD');
        end: moment(String(this.dateFilter.endDate)).format("YYYY-MM-DD"),
      };
      let company = this.companyDashboard?.company_id
        ? this.companyDashboard?.company_id
        : "";
      return this.$http
        .get(
          baseURI +
            `?created_date=${dataSend.start}~${dataSend.end}&company_id=${company}`,
        )
        .then((response) => {
          this.loading();
          this.chartDataLine = {};
          let res = response.data.datas;
          let type = [];
          let data = [];
          res.forEach((item) => {
            type.push(item.proforma_invoice_header_status);
            data.push(item.total);
          });
          console.log(data);
          this.chartDataLine = {
            labels: type,
            datasets: [
              {
                label: "Data One",
                backgroundColor: "#f87979",
                data: data,
              },
            ],
          };

          console.log(this.chartDataLine);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    loadGrafik() {
      this.chartDataLine = {
        labels: this.bulan,
        datasets: [
          {
            label: "Data One",
            backgroundColor: "#f87979",
            data: [40, 20],
          },
        ],
      };
    },
    loadItems() {
      this.fade(true);
      const baseURI =
        this.$settings.endPointProformaInvoice + "v1/proforma-invoice/index";
      let dataSend = {
        start: moment(String(this.dateFilterSearch.startDate)).format(
          "YYYY-MM-DD",
        ), //this.dateFilter.startDate,  // moment(String(this.forms.join_date)).format('YYYY-MM-DD');
        end: moment(String(this.dateFilterSearch.endDate)).format("YYYY-MM-DD"),
      };
      let company = this.company?.company_id ? this.company?.company_id : "";

      return this.$http
        .get(
          baseURI +
            `?limit=${this.serverParams.per_page}&page=${
              this.serverParams.page
            }&sort_field=${this.serverParams.sort.field}&sort_type=${
              this.serverParams.sort.type
            }&pi_number=${
              this.search?.pi_number ? this.search.pi_number : ""
            }&load_id=${
              this.search?.load_id ? this.search.load_id : ""
            }&status=${
              this.search?.status ? this.search.status : ""
            }&created_date=${dataSend.start}~${
              dataSend.end
            }&company_id=${company}&type=dashboard`,
        )
        .then((response) => {
          this.rows = [];
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
          this.loading();
        })
        .catch((error) => {
          console.error(error);
        });
    },

    downloadData() {
      this.fade(true);
      const baseURI =
        this.$settings.endPointProformaInvoice + "v1/proforma-invoice/index";
      let dataSend = {
        start: moment(String(this.dateFilterSearch.startDate)).format(
          "YYYY-MM-DD",
        ), //this.dateFilter.startDate,  // moment(String(this.forms.join_date)).format('YYYY-MM-DD');
        end: moment(String(this.dateFilterSearch.endDate)).format("YYYY-MM-DD"),
      };

      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = `dashboard_proforma_invoice_` + CurrentDate + `.xlsx`;

      let company = this.company?.company_id ? this.company?.company_id : "";

      return this.$http
        .get(
          baseURI +
            `?limit=${this.serverParams.per_page}&page=${
              this.serverParams.page
            }&sort_field=${this.serverParams.sort.field}&sort_type=${
              this.serverParams.sort.type
            }&pi_number=${
              this.search?.pi_number ? this.search.pi_number : ""
            }&load_id=${
              this.search?.load_id ? this.search.load_id : ""
            }&status=${
              this.search?.status ? this.search.status : ""
            }&created_date=${dataSend.start}~${
              dataSend.end
            }&company_id=${company}&type=dashboard&download=download`,
          {
            responseType: "blob", // 🔥 IMPORTANT FIX
          },
        )
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    downloadDataDetail() {
      let dataSend = {
        start: moment(String(this.dateFilter.startDate)).format("YYYY-MM-DD"),
        end: moment(String(this.dateFilter.endDate)).format("YYYY-MM-DD"),
        branch: this.branch.branch_id == undefined ? "" : this.branch.branch_id,
        type:
          this.type_truck.type_truck == undefined
            ? ""
            : this.type_truck.type_truck,
      };

      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = `dashboard_detail_fullfilment_` + CurrentDate + `.xlsx`;

      const baseURI =
        this.$settings.endPoint +
        "/control-tower/transport-order-header/dashboard-download-detail";

      this.$http
        .get(
          baseURI +
            `?start=${dataSend.start}&end=${dataSend.end}&type=${dataSend.type}&branch=${dataSend.branch}`,
          {
            responseType: "blob",
          },
          { timeout: 10000 },
        )
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          } else {
            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.error(error.response.data.errors.message);
              } else {
                //this.$router.push("/page-not-found");
              }
            }
          }
        });
    },

    drawDatasetPointsLabels() {},
    downloadSummary() {
      let dataSend = {
        start: moment(String(this.dateFilter.startDate)).format("YYYY-MM-DD"),
        end: moment(String(this.dateFilter.endDate)).format("YYYY-MM-DD"),
      };
      this.isLoading = true;
      const baseURI =
        this.$settings.endPointCt + "truck-utility-detail/download-summary";
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = `summary_truck_utility_` + CurrentDate + `.xlsx`;

      return this.$http
        .get(baseURI + `?start=${dataSend.start}&end=${dataSend.end}`, {
          responseType: "blob",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        });
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSelectTypeTruck(ev) {
      this.type_truckFilter.push(ev.type_truck_id);
    },

    onUnselectTypeTruck(ev) {
      this.type_truckFilter.splice(
        this.type_truckFilter.indexOf(ev.type_truck_id),
        1,
      );
    },
    onUnselectBranch(ev) {
      this.branchFilter.splice(this.branchFilter.indexOf(ev.branch_id), 1);
      this.branchName.splice(this.branchFilter.indexOf(ev.branch_name), 1);
    },

    onSelectBranch(ev) {
      this.branchFilter.push(ev.branch_id);
      this.branchName.push(ev.branch_name);
    },

    loadTruck() {
      const baseURI = this.$settings.endPointCt + `type-truck/select?limit=10`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchTruck = response.data.datas.data;
      });
    },
    loadBranch() {
      const baseURI = this.$settings.endPointCt + `branch/select`;
      return this.$http.get(baseURI).then((response) => {
        this.fetchBranch = response.data.datas.data;
      });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      let rolePermision = [];
      // console.log(userDatas.sub)
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "ProformaInvoiceController") {
          rolePermision = permision;
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;
    },
    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () {},
  mounted() {
    this.fetchIt();
    this.loadData();
    this.loadItems();
    this.loadCompany();
  },
};
</script>
<style>
button.gm-ui-hover-effect {
  visibility: hidden;
}

.blur-content {
  filter: blur(5px);
}

.box {
  width: 300px;
  height: 10%;
  border-style: solid;
  border-width: 0.5px;
  background-color: red;
  text-align: center;
  vertical-align: middle;
}

.progress {
  width: 150px;
  height: 150px;
  line-height: 150px;
  background: none;
  margin-top: -30%;
  margin-left: 70%;
  box-shadow: none;
  position: relative;
  opacity: 0.8;
}

.progress:after {
  content: "";
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 12px solid #fff;
  position: absolute;
  top: 0;
  right: 0;
}

.progress > span {
  width: 50%;
  height: 100%;
  overflow: hidden;
  position: absolute;
  top: 0;
  z-index: 1;
}

.progress .progress-left {
  left: 0;
}

.progress .progress-bar {
  width: 100%;
  height: 100%;
  background: none;
  border-width: 12px;
  border-style: solid;
  position: absolute;
  top: 0;
}

.progress .progress-left .progress-bar {
  left: 100%;
  border-top-right-radius: 80px;
  border-bottom-right-radius: 80px;
  border-left: 0;
  -webkit-transform-origin: center left;
  transform-origin: center left;
}

.progress .progress-right {
  right: 0;
}

.progress .progress-right .progress-bar {
  left: -100%;
  border-top-left-radius: 80px;
  border-bottom-left-radius: 80px;
  border-right: 0;
  -webkit-transform-origin: center right;
  transform-origin: center right;
  animation: loading-1 1.8s linear forwards;
}

.progress .progress-value {
  width: 90%;
  height: 90%;
  border-radius: 50%;
  background: #eaf0f4;
  font-size: 24px;
  color: rgb(65, 65, 65);
  line-height: 135px;
  text-align: center;
  position: absolute;
  top: 5%;
  left: 5%;
}

.progress.blue .progress-bar {
  border-color: #097fc9;
}

.progress.blue .progress-left .progress-bar {
  animation: loading-2 1.5s linear forwards 1.8s;
}

.progress.yellow .progress-bar {
  border-color: #fdba04;
}

.progress.yellow .progress-left .progress-bar {
  animation: loading-3 1s linear forwards 1.8s;
}

.progress.pink .progress-bar {
  border-color: #ed687c;
}

.progress.pink .progress-left .progress-bar {
  animation: loading-4 0.4s linear forwards 1.8s;
}

.progress.green .progress-bar {
  border-color: #1abc9c;
}

.progress.green .progress-left .progress-bar {
  animation: loading-5 1.2s linear forwards 1.8s;
}

@keyframes loading-1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}

@keyframes loading-2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}

@keyframes loading-3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
  }
}

@keyframes loading-4 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(36deg);
    transform: rotate(36deg);
  }
}

@keyframes loading-5 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(126deg);
    transform: rotate(126deg);
  }
}

@media only screen and (max-width: 990px) {
  .progress {
    margin-bottom: 20px;
  }
}
</style>
